import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import BaseStepper from "../../components/modules/BaseStepper";
import CRMRetargetingModal from "../../components/Advertisers/CRMRetargetingModal";
import PageLayout from "../../layouts/PageLayout";
import { BaseStep } from "../../components/modules/BaseStepper/BaseStepper";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";
import {
  CRMRetargetingSegmentsSelectionStep,
  PublicationListSelectionStep,
  RoleTitleSelectionStep,
  StateProvinceSelectionStep,
  TargetCompaniesSelectionStep,
  VisitorsRetargetingSegmentsSelectionStep,
  ZipCodeSelectionStep,
  steps as defaultSteps,
} from "../../constants/steps";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";
import { createCampaign, resetCampaignToCreateState } from "../../redux/reducers/campaignToCreate";

type LocationState = {
  title?: string;
};

const ManagedCampaignCreatePage = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const title = location.state?.title ?? "Ad Campaign";

  const [steps, setSteps] = useState<BaseStep[]>(defaultSteps);
  const campaignSteps = useSelector((state: ReduxApplicationState) => state.campaignToCreate.campaignSteps);

  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(resetCampaignToCreateState());
    history.push("/dashboard");
  };

  useEffect(() => {
    if (!campaignSteps || campaignSteps.length === 0) {
      return;
    }

    const updatedSteps = defaultSteps.slice();
    campaignSteps.forEach((stepKey: any) => {
      switch (stepKey) {
        case CAMPAIGN_STEPS.ROLE_TITLES:
          updatedSteps.push(RoleTitleSelectionStep);
          break;
        case CAMPAIGN_STEPS.TARGET_COMPANIES:
          updatedSteps.push(TargetCompaniesSelectionStep);
          break;
        case CAMPAIGN_STEPS.PUBLICATION_LISTS:
          updatedSteps.push(PublicationListSelectionStep);
          break;
        case CAMPAIGN_STEPS.ZIP_CODES:
          updatedSteps.push(ZipCodeSelectionStep);
          break;
        case CAMPAIGN_STEPS.STATE_PROVINCES:
          updatedSteps.push(StateProvinceSelectionStep);
          break;
        case CAMPAIGN_STEPS.VISITORS_RETARGETING_SEGMENTS:
          updatedSteps.push(VisitorsRetargetingSegmentsSelectionStep);
          break;
        case CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS:
          updatedSteps.push(CRMRetargetingSegmentsSelectionStep);
          break;
        default:
          break;
      }
    });

    setSteps(updatedSteps);
  }, [campaignSteps, history]);

  return (
    <>
      <PageLayout heading={`${title} Creation`}>
        <BaseStepper
          steps={steps}
          handleBack={handleBack}
          lastStepNextLabel="Create"
          nonLinear
          campaignAction={createCampaign}
        />
      </PageLayout>
      <CRMRetargetingModal />
    </>
  );
};

export default ManagedCampaignCreatePage;
